import { Component, Inject, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { ScheduleComponent } from 'src/app/shared/components/schedule/schedule.component';
import { IconService } from 'src/app/shared/services/icon.service';
import { FullscreenComponent } from 'src/app/shared/additional-styles/fullscreen-component';

@Component({
  selector: 'app-schedule-page',
  templateUrl: './schedule-page.component.html'
})
export class SchedulePageComponent extends FullscreenComponent implements OnInit, OnDestroy {
  data: any;
  @Input({ required: true }) set pageData(value: any) {
    if (value) {
      if(value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
      } else {
        value.icon = 'schedule';
      }  
      this.data = value;
    }
  }

  isServerError: boolean = false;

  constructor(
    private iconService: IconService,
    renderer: Renderer2, 
    @Inject(DOCUMENT) document: Document
  ) {
    super(renderer, document);
  }

  @ViewChild(ScheduleComponent) scheduleComponent!: ScheduleComponent;

  ngOnInit() {
    super.setAddithonalStyles();
    this.isServerError = this.data.isTimeoutErrorAppeared;
  }

  ngOnDestroy() {
    super.setAddithonalStyles(true);
  }

  printBtnClick() {
    window.print(); //TODO: print
  }

  addToCalendarClick(type: CalendarItemEnum) {
    this.scheduleComponent.addToCalendarEvent(type);
  }

  serverErrorAppeared() {
    this.isServerError = true;
  }
}
